import type React from 'react';

export const OPENCODE_GO_MODEL_OPTIONS = ['deepseek-v4-flash', 'deepseek-chat'] as const;

export const sectionStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: '8px 0 20px',
  borderBottom: '1px solid var(--z-border)',
  maxWidth: 560,
};

export const labelStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: 'var(--z-text-2)',
  letterSpacing: '0.02em',
};

export const inputStyle: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '10px 12px',
  borderRadius: 10,
  border: '1px solid var(--z-border)',
  background: 'var(--z-surface)',
  color: 'var(--z-text)',
  fontSize: 13,
  fontFamily: 'inherit',
};

export const hintStyle: React.CSSProperties = {
  fontSize: 12,
  color: 'var(--z-dim)',
  lineHeight: 1.45,
};

export const buttonRowStyle: React.CSSProperties = {
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
  alignItems: 'center',
};

export const fieldGridStyle: React.CSSProperties = {
  display: 'grid',
  gap: 12,
  gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
};

export const savedChipStyle: React.CSSProperties = {
  fontSize: 11.5,
  fontWeight: 600,
  color: 'var(--z-ok, #166534)',
  letterSpacing: '0.01em',
};

export const statusChipStyle = (ok: boolean): React.CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  borderRadius: 999,
  fontSize: 11.5,
  fontWeight: 700,
  background: ok ? 'var(--z-ok-soft, #dcfce7)' : 'var(--z-fill-2)',
  color: ok ? 'var(--z-ok, #166534)' : 'var(--z-dim)',
});
